/* eslint-disable */
/**
 * 该文件是为了按需加载，剔除掉了一些不需要的框架组件。
 * 减少了编译支持库包大小
 *
 * 当需要更多组件依赖时，在该文件加入即可
 */
import Vue from "vue";
import {
  Form,
  FormItem,
  Row,
  Col,
  Input,
  Select,
  Option,
  Checkbox,
  Button,
  Tooltip,
  Dialog,
  Container,
  Header,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Aside,
  Menu,
  Submenu,
  MenuItem,
  Main,
  Message,
} from "element-ui";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import './global.css'


Vue.use(Form);
Vue.use(FormItem);
Vue.use(Row);
Vue.use(Col);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Checkbox);
Vue.use(Button);
Vue.use(Tooltip);
Vue.use(Dialog);
Vue.use(Container);
Vue.use(Header);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Aside);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Main);
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.prototype.$message = Message;
